import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, Pagination } from "swiper";
import { StyleType } from "../UI/Button";
import "swiper/swiper.min.css";
import "./pagination.css";
import style from "./index.module.css";
import { useMemo, useEffect, useState } from "react";
import { useTranslation } from "../../hooks/useTranslation";
import * as ReactDOMServer from "react-dom/server";
import { vehicleModules } from "../../utils/GeneralTypes";
import { getBannersFiltered } from "../../utils/fetcher";

SwiperCore.use([Autoplay, Pagination]);

const HomeSlider = () => {
  const { locale, siteLang } = useTranslation();
  const [banners, setBanners] = useState<any[]>([]);

  useEffect(() => {
    getBannersFiltered("home_page_slider").then((response) => {
      if (response?.data?.banners && Array.isArray(response.data.banners) && response.data.banners.length > 0) {
        setBanners(response.data.banners);
      }
    });
  }, []);

  // Build slider items: only include a vehicle module if there's a matching banner.
  const sliders = useMemo<SliderType>(() => {
    return vehicleModules
      .map((module, index) => {
        const matchingBanner = banners.find((banner) => banner.name === module.single);
        if (matchingBanner) {
          return {
            image: matchingBanner.image,
            heading:
              matchingBanner.title ||
              `${locale("looking_for")} ${locale("a")}${locale(module.single)}${locale("questionMark")}`,
            direction: (index % 2 === 0 ? "start" : "end") as "start" | "end",
            ctasStyle: "row" as "row",
            cta: {
              text: (matchingBanner.subtitle || locale("new")) as string,
              link: matchingBanner.link as string,
              style: "primary" as StyleType,
            },
          };
        }
        return null;
      })
      .filter((slider): slider is NonNullable<typeof slider> => slider !== null);
  }, [locale, banners]);

  const filteredModules = useMemo(() => {
    return vehicleModules.filter((module) => banners.some((banner) => banner.name === module.single));
  }, [banners]);
  
  if (banners && sliders.length > 0) {
    return (
      <Swiper
        className={`${style.main_slider} vehicles_slider`}
        dir={siteLang === "ar" ? "rtl" : "ltr"}
        pagination={{
          clickable: true,
          renderBullet: (index, className) => {
            return ReactDOMServer.renderToStaticMarkup(
              <span className={className}>
                {filteredModules.map((module, moduleIndex) =>
                  index === moduleIndex ? <module.Icon key={moduleIndex} color="black" height="35" width="35" /> : null,
                )}
              </span>,
            );
          },
        }}
        autoplay={{
          pauseOnMouseEnter: true,
          disableOnInteraction: false,
        }}
      >
        {sliders.map((section, index) => (
          <SwiperSlide key={index} className={style.slide}>
            <a href={section.cta.link} target="_self" rel="noreferrer">
              <img src={section.image} alt="" />
            </a>
          </SwiperSlide>
        ))}
      </Swiper>
    );
  } else {
    return <></>;
  }
};

export default HomeSlider;

type SliderType = {
  image: string;
  heading: string;
  ctasStyle: "row" | "column";
  direction: "start" | "end";
  cta: {
    style: StyleType;
    text: string;
    link: string;
  };
}[];
